// In-editor combat playtest: shown when the live document fails
// `@sstk/sunder-sim`'s own completeness validation. Lists the sim's real
// problems verbatim - no synthesised message, no fallback map, per the
// "never introduce dummy fallback data" rule: the fix is always "the
// creator adds what's missing," never "silently substitute something else."
import type { MapProblem } from '@sstk/sunder-sim';

export function PlaytestValidationPanel({
  problems,
  onClose,
}: {
  problems: MapProblem[];
  onClose: () => void;
}) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(6,6,8,0.6)',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'var(--ss-surface, #17181c)',
          border: '1px solid var(--ss-border-soft, rgba(255,255,255,0.12))',
          borderRadius: 12,
          padding: '20px 24px',
          maxWidth: 480,
          color: 'var(--ss-text, #fff)',
          fontFamily: 'var(--ss-sans, sans-serif)',
        }}
        onClick={(event) => event.stopPropagation()}
      >
        <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 4 }}>Can&apos;t playtest yet</div>
        <div style={{ fontSize: 13, opacity: 0.75, marginBottom: 14 }}>
          This map does not meet Sunder&apos;s completeness rules for a match. Fix the following, then try again:
        </div>
        <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13, lineHeight: 1.6 }}>
          {problems.map((problem, i) => (
            <li key={i}>{problem.message}</li>
          ))}
        </ul>
        <button
          type="button"
          onClick={onClose}
          style={{
            marginTop: 18,
            background: 'var(--ss-accent, #6a5cf5)',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '8px 16px',
            fontSize: 13,
            cursor: 'pointer',
          }}
        >
          Back to editing
        </button>
      </div>
    </div>
  );
}
